
import _ from 'lodash'
import moment from 'moment'

import Utils from '@/utils/utils'

export default {
  created() {
    // TODO: Load this from server settings for account
    moment.updateLocale('en-au')
    moment.updateLocale('en-au', {
      calendar: {
        lastDay: '[Yesterday at] LT',
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        lastWeek: '[last] dddd [at] LT',
        nextWeek: 'dddd [at] LT',
        sameElse: 'L [at] LT'
      }
    });
  },
  methods: {
    sanitizeCurrency(value) {
      var output = _.replace(value+'', new RegExp('\\$', 'g'), '')
      output = _.replace(output, new RegExp(',', 'g'), '')
      return output
    },
    capitalizeString(value) {
      if (typeof value !== 'string') return ''
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    convertNewlinesToBreaks(value) {
      if(value == null)
        return ''
      let list = (value+'').trim().split('\n')
      return list.join('<br />')
    },
    convertNewlinesToListItems(value) {
      if(value == null)
        return ''
      let list = (value+'').trim().split('\n')
      return list.map(item => {
        if(item == '')
          return ''
        return `<li>${item}</li>`
      }).join('')
    },

    
    // Apply filters as methods
    // Required by Vue 3.0+ as we look to transition to that in the future
    // Vue 3.0+ deprecates the use of filters

    formatCurrency: function (amount, maximumFractionDigits = 2, hideNullValue = false) {
      return Utils.formatCurrency(amount, maximumFractionDigits, hideNullValue)
    },
    formatCurrencyAccounts: function (amount, maximumFractionDigits = 2, hideNullValue = false) {
      if(amount < 0)
        return '(' + Utils.formatCurrency(-amount, maximumFractionDigits, hideNullValue) + ')'
      return Utils.formatCurrency(amount, maximumFractionDigits, hideNullValue)
    },
    formatCurrencySuffix: function (amount, maximumFractionDigits = 2, hideNullValue = false) {
      return Utils.formatCurrencySuffix(amount, maximumFractionDigits, hideNullValue)
    },

    formatInteger: function(value, hideNullValue = false, useSeperator = false) {
      return Utils.formatInteger(value, hideNullValue, useSeperator)
    },

    formatDecimal: function(value, digits = 2, useSeperator = false) {
      return Utils.formatDecimal(value, digits, useSeperator)
    },

    formatPercent: (value, maximumFractionDigits = 2, useSeperator = false) => {
      return Utils.formatPercent(value, maximumFractionDigits, useSeperator)
    },
    formatPriceWithUOM: (value, uomType) => {
      return Utils.formatPriceWithUOM(value, uomType)
    },

    formatDateCustom: (date, format) => {
      return Utils.formatDateCustom(date, format)
    },

    formatDate: (date) => {
      return Utils.formatDate(date)
    },

    formatTime: (date) => {
      return Utils.formatTime(date)
    },

    formatDateTime: (date) => {
      return Utils.formatDateTime(date)
    },
    formatShortDateTime: (date) => {
      return Utils.formatShortDateTime(date)
    },
    formatTimeOfDay: (timeString) => {
      return Utils.formatTimeOfDay(timeString)
    },

    formatDuration: (seconds, options) => {
      return Utils.formatDuration(seconds, options)
    },

    formatCalenderDate: (date) => {
      return Utils.formatCalenderDate(date)
    },

    formatTimeFromTimeOnly: (time) => {
      return Utils.formatTimeFromTimeOnly(time)
    },
    formatDaysOfWeekList: (dayList) => {
      return Utils.formatDaysOfWeekList(dayList)
    },

    formatBoolean: (value) => {
      return Utils.formatBoolean(value)
    },

    formatLength: (value) => {
      return Utils.formatLength(value)
    },

    formatFileSize: (value) => {
      return Utils.formatFileSize(value)
    },

    formatLookupName: (value, lookupList) => {
      if(lookupList == null)
        return ''
      var matchingList = lookupList.filter(lookupItem => lookupItem.value == value)
      if(matchingList.length)
        return matchingList[0].name
      return ''
    },
    formatLookupKey: (value, lookupList, key) => {
      if(lookupList == null)
        return ''
      var matchingList = lookupList.filter(lookupItem => lookupItem.value == value)
      if(matchingList.length)
        return matchingList[0][key]
      return ''
    },
    formatMultiSelectLookupName: (value, lookupList) => {
      if(_.isArray(value)) {

        return _.compact(
          value.map(selected => {
            let lookup = lookupList.find(lookupItem => lookupItem.value == selected)
            if(lookup)
              return lookup.name
            return null
          })
        ).join(', ')
      }
      return ''
    },
    formatHyphenEmptyValue: (value) => {
      if(value == null || value == '')
        return '-'
      return value
    },

    displayCountPlural: (value) => {
      if(value == 1)
        return ''
      return 's'
    },

    formatNumberOrdinal: (value) => {
      value = parseInt(value)
      var j = value % 10, k = value % 100
      if(j == 1 && k != 11)
        return value + "st"
      if(j == 2 && k != 12)
        return value + "nd"
      if(j == 3 && k != 13)
        return value + "rd"

      return value + "th"
    }
  },
  filters: {
    formatCurrency: function (amount, maximumFractionDigits = 2, hideNullValue = false) {
      return Utils.formatCurrency(amount, maximumFractionDigits, hideNullValue)
    },
    formatCurrencyAccounts: function (amount, maximumFractionDigits = 2, hideNullValue = false) {
      if(amount < 0)
        return '(' + Utils.formatCurrency(-amount, maximumFractionDigits, hideNullValue) + ')'
      return Utils.formatCurrency(amount, maximumFractionDigits, hideNullValue)
    },

    formatInteger: function(value, hideNullValue = false, useSeperator = false) {
      return Utils.formatInteger(value, hideNullValue, useSeperator)
    },

    formatDecimal: function(value, digits = 2, useSeperator = false) {
      return Utils.formatDecimal(value, digits, useSeperator)
    },

    formatPercent: (value) => {
      return Utils.formatPercent(value)
    },
    formatPriceWithUOM: (value, uomType) => {
      return Utils.formatPriceWithUOM(value, uomType)
    },

    formatDateCustom: (date, format) => {
      return Utils.formatDateCustom(date, format)
    },

    formatDate: (date) => {
      return Utils.formatDate(date)
    },

    formatTime: (date) => {
      return Utils.formatTime(date)
    },

    formatDateTime: (date) => {
      return Utils.formatDateTime(date)
    },

    formatCalenderDate: (date) => {
      return Utils.formatCalenderDate(date)
    },
    
    formatShortDateTime: (date) => {
      return Utils.formatShortDateTime(date)
    },

    formatDuration: (seconds, options) => {
      return Utils.formatDuration(seconds, options)
    },

    formatTimeFromTimeOnly: (time) => {
      return Utils.formatTimeFromTimeOnly(time)
    },
    formatDaysOfWeekList: (dayList) => {
      return Utils.formatDaysOfWeekList(dayList)
    },

    formatBoolean: (value) => {
      return Utils.formatBoolean(value)
    },

    formatLength: (value) => {
      return Utils.formatLength(value)
    },

    formatFileSize: (value) => {
      return Utils.formatFileSize(value)
    },

    formatLookupName: (value, lookupList) => {
      if(lookupList == null)
        return ''
      var matchingList = lookupList.filter(lookupItem => lookupItem.value == value)
      if(matchingList.length)
        return matchingList[0].name
      return ''
    },
    formatLookupKey: (value, lookupList, key) => {
      if(lookupList == null)
        return ''
      var matchingList = lookupList.filter(lookupItem => lookupItem.value == value)
      if(matchingList.length)
        return matchingList[0][key]
      return ''
    },
    formatMultiSelectLookupName: (value, lookupList) => {
      if(_.isArray(value)) {

        return _.compact(
          value.map(selected => {
            let lookup = lookupList.find(lookupItem => lookupItem.value == selected)
            if(lookup)
              return lookup.name
            return null
          })
        ).join(', ')
      }
      return ''
    },
    formatHyphenEmptyValue: (value) => {
      if(value == null || value == '')
        return '-'
      return value
    },

    displayCountPlural: (value) => {
      if(value == 1)
        return ''
      return 's'
    }
  }
};
